document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.birthday-select').forEach((select) => {
    select.addEventListener('change', (ev) => {
      const year = ev.target.closest('.birthday-select').querySelectorAll('select')[0];
      const month = ev.target.closest('.birthday-select').querySelectorAll('select')[1];
      const day = ev.target.closest('.birthday-select').querySelectorAll('select')[2];

      const today = new Date();
      let age = today.getFullYear() - year.value;
      const m = today.getMonth() + 1 - month.value;

      if (m < 0 || (m === 0 && today.getDate() < day.value)) age--;
      ev.target.closest('.birthday-select').querySelector('.age').textContent = `( ${age}歳 )`;
    });
  });
});
